import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Squads", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.squads,
      dataKey: "id",
      rowHover: true,
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-plus",
            label: "Agregar",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onClickCreate()), ["prevent"]))
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Nombre",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "",
          style: {"width":"1%"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: _withModifiers(($event: any) => (_ctx.onClickEdit(data)), ["prevent"])
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}